import cl from 'classnames'
import styles from './styles.module.scss'

interface Props {
  className?: string
  title: string
}

export const FAQFranchisePage = ({ className, title }: Props) => {
  return (
    <div className={cl(styles.content, className)}>
      <div className="mb-4">
        <h2 className="font-bold text-2xl">{title}</h2>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="flex flex-col gap-y-4 ">
          <div>
            <h3>Quanto custa instalar energia solar?</h3>
            <p>
              Você que quer descobrir rapidamente quantos painéis solares serão
              necessários e quanto custa instalar energia solar em sua empresa
              ou residência?
            </p>
          </div>

          <p>
            Para descobrir a resposta, basta preencher o formulário com as suas
            informações e o nosso Simulador Solar vai fazer todo o cálculo,
            trazendo as informações que você precisa com clareza e simplicidade.
          </p>

          <div>
            <h3>Como funciona a calculadora solar?</h3>
            <p>
              Por meio dos dados informados no formulário do Cálculo Solar,
              faremos uma estimativa sobre qual é a potência do sistema de
              energia solar que precisa ser instalado em sua residência ou
              empresa.
            </p>
          </div>

          <p>
            Desta forma, você vai saber qual é a área mínima necessária para
            instalação, a quantidade de painéis e suas respectivas capacidades
            em watts, além de informar qual é a estimativa de economia anual que
            será gerada após a instalação.
          </p>

          <p>
            Você também terá acesso a um gráfico com a expectativa de produção
            mensal de energia em KWh/mês com base em dados públicos históricos
            do CRESESB.
          </p>

          <div>
            <h3>O que fazer com o resultado da calculadora solar?</h3>
            <p>
              Você poderá solicitar um orçamento direto ao Portal Solar - nós
              vamos te auxiliar no dimensionamento, cotação e indicação da
              empresa instaladora mais adequada à sua necessidade. <br /> E
              melhor ainda - este é um serviço gratuito!
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-y-4">
          <div>
            <h3>Quem é o Portal Solar?</h3>
            <p>
              O Portal Solar é o maior portal de energia solar da América
              Latina, com mais de 15 mil clientes satisfeitos, 2 mil
              instaladores certificados e uma rede de suporte técnico a nível
              nacional.
            </p>
          </div>

          <div>
            <p>
              Abaixo estão algumas dúvidas frequentes sobre instalação de
              sistemas de energia solar:
            </p>
          </div>

          <div>
            <h3>Preciso ser uma empresa para instalar energia solar?</h3>
            <p>
              Não, pessoas físicas e pessoas jurídicas contam com a oportunidade
              de economizar com a energia solar.
            </p>
          </div>

          <div>
            <h3>Consigo instalar energia solar em apartamento?</h3>
            <p>
              A melhor localização para instalar energia solar em apartamento é
              na cobertura do condomínio, onde há uma ampla área livre e alta
              incidência do sol.
            </p>
          </div>

          <div>
            <h3>
              Tenho baixo consumo em energia elétrica, consigo instalar energia
              solar mesmo assim?
            </h3>
            <p>
              O Cálculo Solar se ajusta de acordo com seu consumo de energia
              elétrica, apresentando a melhor solução para os mais variados
              consumos.
            </p>
          </div>

          <div>
            <h3>
              Por que tenho que preencher o valor do meu gasto com energia
              elétrica e informar qual é minha companhia de energia?
            </h3>
            <p>
              Essas informações são necessárias para que o Cálculo Solar possa
              lhe oferecer os melhores resultados de acordo com seu consumo e
              custo de energia elétrica em sua localização.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
